<script lang="ts">
    import type { Command } from "..";
    export let command: Command;
    export let label: string = command.id;
    export let removeDisabled: boolean = false;
    export let tooltip: string | undefined = undefined;

    const {
        enabled,
        invoke
    } = command;

</script>

<!----------------------------------------------------------------------------->

<slot {command} enabled={$enabled} {invoke}>
    <button disabled={!$enabled} on:click={() => command.invoke()} class:removeDisabled title={tooltip}>
        {label}
    </button>
</slot>

<style>
    .removeDisabled:disabled {
        display: none;
    }
</style>